import React, { Component } from 'react';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ToolTip from '../../components/ToolTip/ToolTip';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

//import Components
import DeleteDialog from "../DeleteDialog/DeleteDialog";
import PageActions from '../PageActions/PageActions';
import PageTitle from '../PageTitle/PageTitle';
import { DeleteIcon } from '../SvgIcons/SvgIcons';

// Import Style
import tableStyle from '../../assets/jss/components/table';

// DND
import { Draggable, DragDropContext, Droppable } from 'react-beautiful-dnd';

// Map Icon
const actionsMap = {
    DELETE: {
        title: 'Delete',
        className: 'delete_icon',
        iClass: <DeleteIcon />
    }
};
/**
 * Re-order - a little function to help us with reordering the result
 * @param {*} list 
 * @param {*} startIndex 
 * @param {*} endIndex 
 * @returns 
 */
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}
/**
 * 
 * @paramGet Item Style {*} isDragging 
 * @param {*} draggableStyle 
 * @returns 
 * 
 * [1]  -   styles we need to apply on draggables
 */
const getItemStyle = (isDragging, draggableStyle) => ({
    // [1]
    ...draggableStyle,

    ...(isDragging && {
        background: "rgb(235,235,235)"
    })
})
/**
 * Tables can be edited
 *
 * @class DragableEditTable
 * @extends {Component}
 */
class DragableEditTable extends Component {
    /**
     *Creates an instance of DragableEditTable.
     * @param {*} props
     * @memberof DragableEditTable
     */
    constructor(props) {
        super(props);
        //state declaration
        this.state = {
            open: false,
            deleteItem: null
        };
    }
    /**
     * Get Field Config
     * @param {*} fieldName 
     * @param {*} item 
     * @param {*} rowIndex 
     * @returns 
     * 
     * [1]  -   if any compoent
     */
    getFieldConfig(fieldName, item, rowIndex) {
        const { componentMap, cellComponentOnChange, config, classes, isReadOnly, isDisabled } = this.props;
        const CellComponent = componentMap[fieldName];
        // [1]
        if (componentMap[fieldName]) {
            return <CellComponent fieldName={fieldName} data={item} onChange={cellComponentOnChange} rowIndex={rowIndex} config={config} classes={classes} isReadOnly={isReadOnly} isDisabled={isDisabled} />
        } else {
            return item[fieldName];
        }
    }
    /**
     * Render Table cell
     * @param {*} fieldName 
     * @param {*} item 
     * @param {*} rowIndex 
     * @returns 
     */
    renderTableCell(fieldName, item, rowIndex) {
        let cellContent = '';
        if (item[fieldName] !== undefined) {
            cellContent = this.getFieldConfig(fieldName, item, rowIndex);
        }

        return cellContent;
    }
    /**
     * Handle Delete Click Open
     * @param {*} item 
     * @param {*} rowIndex 
     */
    handleDeleteClickOpen = (item, rowIndex) => {
        this.setState({
            open: true,
            deleteItem: { ...item, rowIndex }
        });
    }
    /**
     * Render Actions Button
     * @param {*} item 
     * @param {*} rowIndex 
     * @returns 
     */
    renderActionsButton(item, rowIndex) {
        const { actions, deleteTooltip } = this.props;
        return actions.map((action, index) => {
            const { title, className, iClass } = actionsMap[action];
            let buttonTitle = deleteTooltip ? deleteTooltip : title
            return (
                <ToolTip title={buttonTitle} placement="bottom" key={index}>
                    <IconButton
                        className={className}
                        color="primary"
                        aria-label={buttonTitle}
                        onClick={() => this.handleDeleteClickOpen(item, rowIndex)}>
                        {iClass}
                    </IconButton>
                </ToolTip>
            )
        })
    }
    /**
     * Render Table Row
     * @param {*} item 
     * @param {*} rowIndex 
     * @returns 
     * 
     * [1]  -   add actions
     */
    renderTableRow(item, rowIndex) {
        const { fieldCols, actions, section } = this.props;
        const tableCells = fieldCols.map((fieldName, colIndex) => {
            return <TableCell className={fieldName === 'sort' ? 'sort-width' : ''} key={`col_${colIndex}`}>{this.renderTableCell(fieldName, item, rowIndex)}</TableCell>;
        });
        // [1]
        if (actions.length > 0) {
            if (section === 'reserve') {
                if (rowIndex >= 2) {
                    tableCells.push(<TableCell key={`col_${tableCells.length}`}>{this.renderActionsButton(item, rowIndex)}</TableCell>);
                }
            }
            else tableCells.push(<TableCell key={`col_${tableCells.length}`}>{this.renderActionsButton(item, rowIndex)}</TableCell>);
        }
        return tableCells;
    }
    /**
     * Render HF Table Row
     * @param {*} item 
     * @param {*} rowIndex 
     * @param {*} placement 
     * @returns 
     * 
     * [1]  -   add dummy actions column
     */
    renderHFTableRow(item, rowIndex, placement) {
        const { fieldCols, actions } = this.props;
        const tableCells = fieldCols.map((fieldName, colIndex) => {
            return <TableCell key={`col_${placement}_${colIndex}`}>{item[`${fieldName}_${placement}`]}</TableCell>;
        });
        // [1]
        if (actions.length > 0) {
            tableCells.push(<TableCell key={`col_${tableCells.length}`}>{item[`actions_${placement}`]}</TableCell>);
        }
        return <TableRow className={`${placement}-row`} key={`row_${placement}_${rowIndex}`}>{tableCells}</TableRow>;
    }
    /**
     * On Drag ENd
     * @param {*} result 
     * @returns 
     * 
     * [1]  -   dropped outside the list
     */
    onDragEnd = (result) => {
        const { rowDatas } = this.props
        // [1]
        if (!result.destination) {
            return
        }
        const items = reorder(
            rowDatas,
            result.source.index,
            result.destination.index
        )
        this.props.onDragEnd(items)
    }
    /**
     *render html
     *
     * @returns
     * @memberof DragableEditTable
     */
    render() {
        const { headerCols, rowDatas, classes, actions, style, pageTitle, page, pageActions,
            needTitle, footerDatas, tableClass, headerDatas, staticHeader, needActions, requiredFields } = this.props;
        const staticHeaderCls = staticHeader === true ? 'staticHeader' : '';
        return (
            <React.Fragment>
                <div className={style ? classes.width100 : classes.root}>
                    {
                        needTitle && (
                            <Grid container justifyContent='space-between'>                                <Grid item xs={12} sm={8} class="textCenter">
                                    {
                                        page === 'explore' ? <div className={classes.exploreEditTableTitle}>Filter</div> :
                                            <PageTitle
                                                title={pageTitle}
                                                subTitle={''}
                                                actions={[]}
                                            />
                                    }
                                </Grid>
                                { needActions && (
                                    <Grid item xs={12} sm={4}>
                                        <PageActions
                                            actions={pageActions}
                                            handleAddActionClick={() => {
                                                this.props.onAdd();
                                            }}
                                            handlePreviewActionClick={() => {
                                                this.props.handlePreview();
                                            }}
                                        />
                                    </Grid>
                                )
                                }
                            </Grid>
                        )
                    }
                    <div style={staticHeader === false ? style : {}}>
                        <Table className={`${classes.editTable} ${tableClass} ${staticHeaderCls}`}>
                            <TableHead>
                                <TableRow>
                                    {
                                        headerCols.map((header) => {
                                            return <TableCell key={header} className={requiredFields.indexOf(header) >= 0 ? 'required-header' : header ? 'normal-header' : 'normal-header sort-width'}>{header}</TableCell>
                                        })
                                    }
                                    {
                                        actions.length > 0 && <TableCell key={'actions'}>{'ACTIONS'}</TableCell>
                                    }

                                </TableRow>
                                <TableRow className={'loaderRow'}>
                                    <TableCell rowSpan={headerCols.length + 1} colSpan={headerCols.length + 1}>
                                        {this.props.isLoading === true &&
                                            <div className={'linearProgressContainer'}>
                                                <LinearProgress color="primary" />
                                            </div>
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                                <Droppable
                                    droppableId={'1'}
                                    direction="vertical"
                                >
                                    {(provided) => (
                                        <TableBody
                                            style={staticHeader === true ? style : {}}
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {provided.placeholder}
                                            {
                                                headerDatas.map((item, index) => {
                                                    return this.renderHFTableRow(item, index, 'header');
                                                })
                                            }
                                            {rowDatas.map((item, index) => {
                                                return (<Draggable key={index} draggableId={item.key.toString()} index={index}>
                                                    {(provided, snapshot) => (
                                                        <TableRow
                                                            key={`row_${index}`}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                                        >
                                                            {this.renderTableRow(item, index)}
                                                        </TableRow>
                                                    )}
                                                </Draggable>)
                                            })}
                                            {
                                                rowDatas.length === 0 && (
                                                    <TableRow className={'children-row'}>
                                                        <TableCell colSpan={headerCols.length + 1} className="draggableEditTableRow">
                                                            <span className="draggableEditTabNoRec">{"No Records"}</span>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                            {
                                                <TableRow className={'children-row'}>
                                                    <TableCell>
                                                        {this.props.children}
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            {
                                                footerDatas.map((item, index) => {
                                                    return this.renderHFTableRow(item, index, 'footer');
                                                })
                                            }
                                        </TableBody>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Table>
                    </div>
                    <DeleteDialog
                        open={this.state.open}
                        content={"Are you sure you want to delete this record?"}
                        handleDeleteAction={() => {
                            this.props.onDelete(this.state.deleteItem);
                            this.setState({
                                open: false,
                                deleteItem: null
                            })
                        }}
                        id={this.state.deleteItemId}
                        handleDeleteOnCloseAction={() => {
                            this.setState({
                                open: false,
                                deleteItem: null
                            })
                        }}
                    />
                </div>
            </React.Fragment>
        )
    }
}
//default props
DragableEditTable.defaultProps = {
    componentMap: {},
    onDelete: () => { },
    cellComponentOnChange: () => { },
    headerCols: [],
    requiredFields: [],
    fieldCols: [],
    rowDatas: [],
    isLoading: false,
    actions: [],
    classes: {},
    style: {},
    pageTitle: '',
    needTitle: true,
    config: {},
    footerDatas: [],
    tableClass: '',
    headerDatas: [],
    isReadOnly: false,
    staticHeader: false,
    height: '',
    needActions: true,
    deleteTooltip: '',
    page: '',
    pageActions: ['ADD'],
    handleFilter: () => { }
}
/** Export components */
export default withStyles(tableStyle)(DragableEditTable);